// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Column$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as SidePanelFooter from "../../SidePanelFooter.bs.js";
import * as SidePanelHeader from "../../SidePanelHeader.bs.js";
import * as CreateTemplateForm from "./CreateTemplateForm.bs.js";

function CreateTemplateCmp(Props) {
  var set_show_sidepanel = Props.set_show_sidepanel;
  var create_function = Props.create_function;
  var match = React.useState(function () {
        return false;
      });
  var toggleLoader = match[1];
  var form = CreateTemplateForm.Form.useForm({
        title: "",
        body: ""
      }, (function (output, submissionCallbacks) {
          Curry._1(toggleLoader, (function (param) {
                  return true;
                }));
          Curry._3(create_function, output.title, output.body, toggleLoader);
          return Curry._1(submissionCallbacks.notifyOnSuccess, undefined);
        }));
  return React.createElement(Column$Catalyst.make, {
              children: null,
              className: "c-create-template-cmp"
            }, React.createElement(SidePanelHeader.make, {
                  on_close_click: (function (param) {
                      return Curry._1(set_show_sidepanel, false);
                    }),
                  heading: "Create New Template"
                }), React.createElement(CreateTemplateForm.make, {
                  form: form
                }), React.createElement(SidePanelFooter.make, {
                  on_primary_btn_click: form.submit,
                  is_loading: match[0],
                  loader_msg: "Template is being created...",
                  primary_btn_text: "Submit"
                }));
}

var make = CreateTemplateCmp;

export {
  make ,
  
}
/* react Not a pure module */
